import { useParams, Link } from "react-router-dom";
import { posts } from "../data/posts";

export default function BlogPost() {
  const { slug } = useParams();
  const postList = Array.isArray(posts) ? posts : [];
  const post = postList.find((p) => p.slug === slug);

  if (!post) {
    return (
      <main style={{ maxWidth: 820, margin: "0 auto", padding: 24 }}>
        <h2>Post not found</h2>
        <Link to="/blog">Back to Blog</Link>
      </main>
    );
  }

  return (
    <main style={{ maxWidth: 820, margin: "0 auto", padding: 24 }}>
      <Link to="/blog">&larr; Back</Link>

      <article style={{ marginTop: 16 }}>
        <h1>{post.title}</h1>
        <p>{post.description}</p>

        {post.cover ? (
          <img
            src={post.cover}
            alt={post.title}
            style={{ width: "100%", borderRadius: 12, margin: "16px 0" }}
          />
        ) : null}

        <div dangerouslySetInnerHTML={{ __html: post.content }} />
      </article>
    </main>
  );
}
